import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-8 md:mb-12" }
const _hoisted_2 = { class: "mb-4 md:flex md:flex-row md:items-center md:justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mb-4 md:flex-row md:w-1/2" }, null, -1)
const _hoisted_4 = { class: "flex flex-col mb-4 md:flex-row md:w-1/2" }
const _hoisted_5 = { class: "flex flex-row w-full md:justify-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl" }, "-", -1)
const _hoisted_7 = { class: "mb-10 md:flex md:flex-row md:items-center md:justify-between" }
const _hoisted_8 = { class: "w-full mb-4 md:mb-0 md:w-3/5" }
const _hoisted_9 = { class: "flex flex-row items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus ml-2 text-medium mr-1" }, null, -1)
const _hoisted_11 = { class: "hidden md:flex flex-row md:text-center items-center justify-between text-light font-bold text-headings-gray mb-8 px-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-20" }, null, -1)
const _hoisted_13 = { class: "flex flex-row flex-1" }
const _hoisted_14 = { class: "md:text-left w-1/6" }
const _hoisted_15 = { class: "w-1/6" }
const _hoisted_16 = { class: "w-1/6" }
const _hoisted_17 = { class: "w-1/6" }
const _hoisted_18 = { class: "w-1/6" }
const _hoisted_19 = { class: "w-1/6" }
const _hoisted_20 = { class: "w-20 flex flex-row justify-end" }
const _hoisted_21 = ["checked"]
const _hoisted_22 = {
  key: 0,
  class: "rounded bg-white p-6 md:px-4 flex flex-col md:items-center relative mb-5 md:flex-row justify-center font-bold text-medium"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker_input = _resolveComponent("datepicker-input")!
  const _component_search_input = _resolveComponent("search-input")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_return_parcel_list_item = _resolveComponent("return-parcel-list-item")!
  const _component_DynamicForm = _resolveComponent("DynamicForm")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("return_parcels.list.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_datepicker_input, {
            class: "mr-5 md:w-1/4",
            placeholder: "filters.from_date",
            onDateUpdate: _ctx.dateFromUpdate
          }, null, 8, ["onDateUpdate"]),
          _hoisted_6,
          _createVNode(_component_datepicker_input, {
            class: "ml-5 md:w-1/4",
            placeholder: "filters.to_date",
            onDateUpdate: _ctx.dateToUpdate
          }, null, 8, ["onDateUpdate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_search_input, {
          placeholder: "return_parcels.list.filters.search",
          isLoading: _ctx.isLoading,
          onSearchUpdate: _ctx.searchUpdate,
          onSearchAction: _ctx.getList
        }, null, 8, ["isLoading", "onSearchUpdate", "onSearchAction"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_default_button, {
          class: "w-full md:w-auto ml-4",
          onClick: _ctx.createNewReturnParcel
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("return_parcels.list.actions.create_return")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.pagination)
      ? (_openBlock(), _createBlock(_component_pagination, {
          key: 0,
          "total-rows": 20,
          meta: _ctx.pagination,
          onChangePagination: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePagination($event.page, $event.perPage)))
        }, null, 8, ["meta"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.id")), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("parcels.list.item.labels.supplier")), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.created_date")), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.status")), 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.tracking_link")), 1),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.label")), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          (!_ctx.isLoading)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "checkbox",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkReturnParcelsPage && _ctx.checkReturnParcelsPage(...args))),
                checked: _ctx.isReturnParcelsPageChecked,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isReturnParcelsPageChecked) = $event))
              }, null, 40, _hoisted_21)), [
                [_vModelCheckbox, _ctx.isReturnParcelsPageChecked]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_spinner, {
            key: 0,
            class: "mx-auto"
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.returnParcels.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_ctx.loadFailed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("general.list_load_error")), 1))
                    : (
              _ctx.searchedPhrase.length === 0 || _ctx.searchedPhrase.length >= 3
            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("general.empty_list")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("general.empty_list_min_3_characters")), 1))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.returnParcels, (returnParcel) => {
              return (_openBlock(), _createBlock(_component_return_parcel_list_item, {
                key: returnParcel.id,
                returnParcel: returnParcel,
                onCheckReturnParcel: _ctx.checkReturnParcel,
                isChecked: _ctx.isReturnParcelChecked(returnParcel?.id)
              }, null, 8, ["returnParcel", "onCheckReturnParcel", "isChecked"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.pagination)
      ? (_openBlock(), _createBlock(_component_pagination, {
          key: 1,
          "total-rows": 20,
          meta: _ctx.pagination,
          onChangePagination: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePagination($event.page, $event.perPage)))
        }, null, 8, ["meta"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      modelValue: _ctx.showReturnParcelFormModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showReturnParcelFormModal) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.formTitle)), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DynamicForm, {
          formData: _ctx.formData,
          isLoading: _ctx.formLoading,
          isSaving: _ctx.formSaving,
          initValue: _ctx.formValue,
          initValidation: _ctx.formValidation,
          onCancelAction: _ctx.cancelAction,
          onSubmitAction: _ctx.submitAction
        }, null, 8, ["formData", "isLoading", "isSaving", "initValue", "initValidation", "onCancelAction", "onSubmitAction"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}